import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const env = import.meta.env.VITE_APP_ENV;

    let devPrefix = '';
    if (env === 'debug') {
      devPrefix = '[Debug] ';
    } else if (env === 'development') {
      devPrefix = '[Dev] ';
    } else if (env === 'production') {
      devPrefix = '';
    }

    if (pathname.startsWith('/admin')) {
      document.title = `${devPrefix}Admin`;
    } else if (pathname.startsWith('/resume_jd_analysis_trial')) {
      document.title = `${devPrefix}PolarisJobs Trial`;
    } else {
      document.title = `${devPrefix}PolarisJobs`;
    }
  }, [location.pathname]);
};
